
(function () {
  var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js'
  if (window.ShopifyBuy) {
    if (window.ShopifyBuy.UI) {
      Init()
    } else {
      loadScript()
    }
  } else {
    loadScript()
  }

  function loadScript () {
    const script = document.createElement('script')
    script.async = true
    script.src = scriptURL;
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script)
    script.onload = Init
  }

  function Init () {
    document.querySelectorAll('[data-product-embeds]')
      .forEach(host => {
        const productIds = host.dataset.productEmbeds
        const node = document.createElement('div')
        node.classList.add('product-embed-frame')
        host.appendChild(node)
        host = node

        productIds
          .split(',')
          .forEach(productIdyy => {
            ShopifyBuyInit(productIdyy, host)
          })
      })
  }

  function ShopifyBuyInit (product_id, parent) {
    const node = document.createElement('div')
    parent.appendChild(node)

    const client = ShopifyBuy.buildClient({
      domain: '2122b9-2.myshopify.com',
      storefrontAccessToken: '3da4c69cf8366ca36fd6cef9be0bf47e',
    })

    ShopifyBuy.UI.onReady(client).then(function (ui) {
      ui.createComponent('product', {
        id: product_id,
        node: node,
        moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
        options: {
          "product": {
            "styles": {
              "product": {
                "@media (min-width: 601px)": {
                  "max-width": "calc(25% - 20px)",
                  "margin-left": "20px",
                  "margin-bottom": "50px"
                }
              },
              "title": {
                "color": "#000000"
              },
              "button": {
                ":hover": {
                  "background-color": "#493b7a"
                },
                "background-color": "#514288",
                ":focus": {
                  "background-color": "#493b7a"
                },
                "border-radius": "0px"
              },
              "price": {
                "color": "#242424"
              },
              "compareAt": {
                "color": "#242424"
              },
              "unitPrice": {
                "color": "#242424"
              }
            },
            "buttonDestination": "onlineStore",
            "contents": {
              "options": false
            },
            "text": {
              "button": window.blog_i18n.buy_button.button
            }
          },
          "productSet": {
            "styles": {
              "products": {
                "@media (min-width: 601px)": {
                  "margin-left": "-20px"
                }
              }
            }
          },
          "modalProduct": {
            "contents": {
              "img": false,
              "imgWithCarousel": true,
              "button": false,
              "buttonWithQuantity": true
            },
            "styles": {
              "product": {
                "@media (min-width: 601px)": {
                  "max-width": "100%",
                  "margin-left": "0px",
                  "margin-bottom": "0px"
                }
              },
              "button": {
                ":hover": {
                  "background-color": "#493b7a"
                },
                "background-color": "#514288",
                ":focus": {
                  "background-color": "#493b7a"
                },
                "border-radius": "0px"
              },
              "title": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "bold",
                "font-size": "26px",
                "color": "#242424"
              },
              "price": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": "18px",
                "color": "#242424"
              },
              "compareAt": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": "15.299999999999999px",
                "color": "#242424"
              },
              "unitPrice": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": "15.299999999999999px",
                "color": "#242424"
              },
              "description": {
                "color": "#242424"
              }
            },
            "text": {
              "button": "In meine Tasche"
            }
          },
          "option": {
            "styles": {
              "label": {
                "color": "#242424"
              }
            }
          },
          "cart": {
            "styles": {
              "button": {
                ":hover": {
                  "background-color": "#493b7a"
                },
                "background-color": "#514288",
                ":focus": {
                  "background-color": "#493b7a"
                },
                "border-radius": "0px"
              },
              "title": {
                "color": "#242424"
              },
              "header": {
                "color": "#242424"
              },
              "lineItems": {
                "color": "#242424"
              },
              "subtotalText": {
                "color": "#242424"
              },
              "subtotal": {
                "color": "#242424"
              },
              "notice": {
                "color": "#242424"
              },
              "currency": {
                "color": "#242424"
              },
              "close": {
                "color": "#242424",
                ":hover": {
                  "color": "#242424"
                }
              },
              "empty": {
                "color": "#242424"
              },
              "noteDescription": {
                "color": "#242424"
              },
              "discountText": {
                "color": "#242424"
              },
              "discountIcon": {
                "fill": "#242424"
              },
              "discountAmount": {
                "color": "#242424"
              }
            },
            "text": {
              "title": "Meine Tasche",
              "total": "Zwischensumme",
              "empty": "Deine Tasche ist leer.",
              "notice": "Versandkosten und Rabatte werden beim Checkout berechnet.",
              "button": "Checkout"
            }
          },
          "toggle": {
            "styles": {
              "toggle": {
                "background-color": "#514288",
                ":hover": {
                  "background-color": "#493b7a"
                },
                ":focus": {
                  "background-color": "#493b7a"
                }
              }
            }
          },
          "lineItem": {
            "styles": {
              "variantTitle": {
                "color": "#242424"
              },
              "title": {
                "color": "#242424"
              },
              "price": {
                "color": "#242424"
              },
              "fullPrice": {
                "color": "#242424"
              },
              "discount": {
                "color": "#242424"
              },
              "discountIcon": {
                "fill": "#242424"
              },
              "quantity": {
                "color": "#242424"
              },
              "quantityIncrement": {
                "color": "#242424",
                "border-color": "#242424"
              },
              "quantityDecrement": {
                "color": "#242424",
                "border-color": "#242424"
              },
              "quantityInput": {
                "color": "#242424",
                "border-color": "#242424"
              }
            }
          }
        },
      })
    })
  }
})()
